module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "thehistoryof51"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Order of St. Anna")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Orden Sv. Anny")]), _vm._v(") was established by Prince Karl Friedrich of Holstein in 1735 to honor his wife, Anna Petrovna (daughter of Peter the Great). When his son Prince Karl Peter Ulrich became Emperor Peter III of Russia, the Order was officially proclaimed one of the highest Russian awards. While the first and second class Orders were variations of the cross, the third (fourth after 1815) class Order was a small badge fastened to an officer’s sword or saber. The first class Order was reserved primarily for generals and second and third classes for senior officers. During the Napoleonic Wars, many officers received the third class Order, including 664 men in 1812, 751 in 1813, and more than 1,090 in 1814. In some cases, soldiers and non-commissioned officers were decorated with the Medal of Distinction of the Order of St. Anna ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("znak otlichia ordena sv. Anny")]), _vm._v(") when they participated in celebrated campaigns or engagements. Soldiers who earned the medal received higher pay and could not be sentenced to corporal punishment. Three hundred men in Prince Peter Bagration’s troops received this medal after the famous rearguard action at Schöngrabern in November 1805. In 1807, Emperor Alexander included awarding of this medal to soldiers and non-commissioned officers who served 20 years.")]), _vm._v(" "), _c('p', {
    staticClass: "para2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Motto")]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(":")]), _vm._v(" “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Amantibus Justitiam, Pietateret Fidem")]), _vm._v("” (Truth, Honor, and Fidelity to the Beloved)")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Color of Ribbon:")]), _vm._v(" Red with Yellow hems")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d392e3de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/therussian_thehistoryof51.vue
// module id = 273
// module chunks = 0